// extracted by mini-css-extract-plugin
module.exports = {"list":"NewsList-module--list--a0ZrT","listItem":"NewsList-module--listItem--2Cx6c","noNews":"NewsList-module--noNews--TDRIE"};